import $ from 'jquery'

$('.faq__title').on('click', function () {
    const $faq = $(this).closest('.faq')
    const $content = $faq.children('.faq__content')
    const content = $content.get(0)
    if (!content) return

    if ($faq.hasClass('is-open')) {
        $content.css('height', content.scrollHeight + 'px')
        content.offsetHeight
        $content.css('height', 0)
        $faq.removeClass('is-open')
        return
    }

    $faq.addClass('is-open')
    $content.css('height', content.scrollHeight + 'px')
    $content.one('transitionend', function (event) {
        if (event.target !== content || !$faq.hasClass('is-open')) return
        $content.css('height', 'auto')
    })
})
